module.exports = __webpack_public_path__ + "img/solution-data-advantage4.6c2c464d.svg";